export const environment = {
  production: true,
  apiUrl: 'https://api.promojds.fr',
  kindeClientId: 'cbbf02e02f584a38a0530c63abba19af',
  kindeAuthDomain: 'https://auth.promojds.fr',
  kindeRedirectUrl: 'https://promojds.fr',
  kindeLogoutRedirectUrl: 'https://promojds.fr',
  cookieDomain: 'promojds.fr',
  amplitudeApiKey: '3e35a5c036a6f2b41a2d96e6896b278a'
};
